import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCurrentActor } from '../../services/auditLogService';
import { changeFoodOrderStatus, isActiveFoodStay } from '../../services/foodOrderService';
import FoodMenuPanel, { foodButtonStyle } from './FoodMenuPanel';
export default function FoodOrdersPanel({
  hotelId,
  enabled,
  stayRecords = new Map(),
  dark = false
}) {
  const [data, setData] = useState({
    hotelId: '',
    orders: [],
    ready: false,
    error: ''
  });
  const [open, setOpen] = useState(false),
    [setup, setSetup] = useState(false),
    [tab, setTab] = useState('pending'),
    [busy, setBusy] = useState(''),
    [error, setError] = useState('');
  useEffect(() => {
    setOpen(false);
    setSetup(false);
    setError('');
    setData({
      hotelId,
      orders: [],
      ready: false,
      error: ''
    });
    if (!enabled || !hotelId) return undefined;
    const failed = e => setData(current => ({
      ...current,
      error: e.message
    }));
    const stopOrders = onSnapshot(query(collection(db, 'foodOrders'), where('hotelId', '==', hotelId)), snapshot => setData(current => ({
      ...current,
      orders: snapshot.docs.map(item => ({
        ...item.data(),
        id: item.id
      })).filter(item => item.status !== 'deleted').sort((a, b) => String(b.addedAt).localeCompare(String(a.addedAt))),
      ready: true,
      error: ''
    })), failed);
    return () => stopOrders();
  }, [hotelId, enabled]);
  const orders = data.hotelId === hotelId ? data.orders : [],
    pending = orders.filter(order => order.status === 'pending').length;
  async function action(order, next) {
    if (next === 'delete' && !window.confirm('Order tracking/history se remove karein? Guest ke bill ka charge nahi hatega.')) return;
    setBusy(order.id);
    setError('');
    try {
      await changeFoodOrderStatus({
        database: db,
        hotelId,
        order,
        action: next,
        actor: getCurrentActor()
      });
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy('');
    }
  }
  return <>
    <button type="button" className="pms-stat-card" disabled={!enabled} onClick={() => setOpen(true)} aria-label={`FOOD ORDERS: ${data.error ? 'load error' : !data.ready ? 'loading' : `${pending} pending`}`} style={{
      minHeight: 72,
      padding: '11px 14px',
      borderRadius: 14,
      border: `1px solid ${dark ? '#80652b' : '#eadfc8'}`,
      background: dark ? 'linear-gradient(135deg,#31270f 0%,#3a2d11 100%)' : 'linear-gradient(135deg,#fffdfa 0%,#fff9ef 100%)',
      color: dark ? '#f2cf78' : '#8a6118',
      cursor: 'pointer',
      textAlign: 'left',
      fontWeight: 900,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12
    }}>
      <div style={{fontSize: 11, letterSpacing: '.04em', fontWeight: 950}}>
        PENDING ORDERS
        <div style={{marginTop: 5, fontSize: 12, letterSpacing: 0}}>{data.error ? 'Load error' : !data.ready ? 'Loading…' : `${pending} Pending`}</div>
      </div>
      <div aria-hidden="true" style={{width: 42, height: 42, borderRadius: '50%', display: 'grid', placeItems: 'center',
        background: dark ? 'rgba(242,207,120,.12)' : '#fbefd7', border: `1px solid ${dark ? '#80652b' : '#f1dfbb'}`,
        color: dark ? '#f2cf78' : '#8b641c', flex: '0 0 auto'}}>
        <svg width="27" height="27" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 23h20M8 21a8 8 0 0 1 16 0H8ZM16 10V8M14 8h4M4 26h24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </button>
    {open && <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 19000,
      background: 'rgba(0,0,0,.6)',
      display: 'grid',
      placeItems: 'center',
      padding: 12
    }}>
      <section role="dialog" aria-modal="true" aria-label="Food Orders" style={{
        width: 'min(900px,95vw)',
        maxHeight: '88vh',
        overflowY: 'auto',
        borderRadius: 16,
        padding: 20,
        background: '#fff',
        color: '#0f172a'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 8,
          flexWrap: 'wrap'
        }}><h2 style={{
            margin: 0
          }}>Food Orders</h2><button style={foodButtonStyle} disabled={!!busy} onClick={() => setOpen(false)}>Close</button></div>
        <p>{hotelId}</p><div style={{
          display: 'flex',
          gap: 8,
          flexWrap: 'wrap'
        }}><button style={foodButtonStyle} onClick={() => setTab('pending')}>Pending ({pending})</button><button style={foodButtonStyle} onClick={() => setTab('done')}>Done / History ({orders.filter(item => item.status === 'done').length})</button><button style={foodButtonStyle} onClick={() => setSetup(true)}>Menu Setup</button></div>
        {(error || data.error) && <p role="alert" style={{
          color: '#b91c1c'
        }}>{error || data.error}</p>}
        <p style={{
          fontSize: 13
        }}>Done = room tak deliver ho gaya. Undo/Delete se guest bill change nahi hoga.</p>
        {orders.filter(order => order.status === tab).length === 0 && <p>{data.ready ? 'Is list mein koi order nahi hai.' : 'Loading orders…'}</p>}
        {orders.filter(order => order.status === tab).map(order => {
          const record = stayRecords.get(order.stayId),
            stay = record?.hotelId === hotelId ? record : null,
            active = isActiveFoodStay(stay),
            room = active ? stay.room : order.deliveredRoom || stay?.room || order.room;
          return <article key={order.id} style={{
            border: '1px solid #cbd5e1',
            borderRadius: 12,
            padding: 14,
            marginTop: 10
          }}>
            <b>Room {room} · {order.guestName}</b><div style={{
              margin: '7px 0'
            }}>{order.quantity} × {order.title} {order.unit && `(${order.unit})`} · ₹{order.amount}</div>
            <div style={{
              fontSize: 13
            }}>Ordered: {new Date(order.addedAt).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata'
              })}{order.note && ` · ${order.note}`}</div>
            {stay && !active && <p style={{
              color: '#b45309'
            }}>Guest checkout ho chuka hai. Order ki delivery verify karein.</p>}
            {order.status === 'done' && <p style={{
              fontSize: 13
            }}>Delivered: {order.deliveredAt && new Date(order.deliveredAt).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata'
              })} · {order.deliveredByName} · Room {order.deliveredRoom}</p>}
            <div style={{
              display: 'flex',
              gap: 8,
              marginTop: 10
            }}><button style={foodButtonStyle} disabled={!!busy || !active} onClick={() => action(order, order.status === 'done' ? 'undo' : 'done')}>{busy === order.id ? 'Saving…' : order.status === 'done' ? 'Undo' : 'Order Done'}</button><button style={{
                ...foodButtonStyle,
                color: '#b91c1c'
              }} disabled={!!busy} onClick={() => action(order, 'delete')}>Delete</button></div>
          </article>;
        })}
      </section>
    </div>}
    {setup && <FoodMenuPanel hotelId={hotelId} onClose={() => setSetup(false)} />}
  </>;
}
